export default {
  statusReleasePayment(state) {
    const { content = [] } = state || {};

    return content.map(item => Object.values(item)).map(item => [item[1], item[2]]);
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/analytics/components/analytics-status-release-payment/store/getters.js